module.exports = __webpack_public_path__ + "static/media/main.db99e97a.png";